var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _g, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 111,
    viewBox: "0 0 156 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7174_39852)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 110,
    transform: "translate(0 0.562378)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40,
    y: 28.5122,
    width: 34.202,
    height: 5.21,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40,
    y: 35.2666,
    width: 38.0641,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40,
    y: 39.4849,
    width: 42.9645,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40,
    y: 43.7012,
    width: 21.4058,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 133.852,
    y: 32.2598,
    width: 13.9385,
    height: 5.00684,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 117.333,
    y: 32.2598,
    width: 13.9385,
    height: 5.00684,
    rx: 1,
    fill: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7174_39852)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7174_39852)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7174_39852",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: 24,
    width: 51,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2273 24.6262H-8.22727C-8.65404 24.6262 -9 24.9653 -9 25.3835V49.6165C-9 50.0347 -8.65404 50.3738 -8.22727 50.3738H41.2273C41.654 50.3738 42 50.0347 42 49.6165V25.3835C42 24.9653 41.654 24.6262 41.2273 24.6262Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7174_39852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2273 24.6262H-8.22727C-8.65404 24.6262 -9 24.9653 -9 25.3835V49.6165C-9 50.0347 -8.65404 50.3738 -8.22727 50.3738H41.2273C41.654 50.3738 42 50.0347 42 49.6165V25.3835C42 24.9653 41.654 24.6262 41.2273 24.6262Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.1922 41.1093C35.27 41.1349 42.7948 46.056 45.2655 46.6199C47.7364 47.1838 46.9503 50.4389 46.9503 50.4389H7.13623C7.13623 50.4389 21.1188 42.9291 22.7475 43.3136C24.3759 43.698 24.1512 44.5694 25.555 44.5951C26.9591 44.6207 31.1145 41.0837 33.1922 41.1093Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.38288 37.574C-2.71725 37.6094 -7.54982 44.3953 -9.13664 45.1728C-10.7235 45.9504 -10.2186 50.4389 -10.2186 50.4389H15.3508C15.3508 50.4389 6.37087 40.0835 5.32501 40.6136C4.27915 41.1438 4.42347 42.3454 3.52185 42.3807C2.62021 42.4161 -0.0485086 37.5388 -1.38288 37.574Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7594 43.6207C32.4249 43.6394 27.5922 47.2359 26.0056 47.648C24.4187 48.0601 24.9235 50.4389 24.9235 50.4389H50.493C50.493 50.4389 41.5129 44.9506 40.4672 45.2316C39.4214 45.5126 39.5657 46.1494 38.6641 46.1682C37.7624 46.1869 35.0936 43.602 33.7594 43.6207Z",
    fill: "#D9D9D9"
  }))))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40,
    y: 60.5122,
    width: 34.202,
    height: 5.21,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40,
    y: 67.2666,
    width: 38.0641,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40,
    y: 71.4849,
    width: 42.9645,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40,
    y: 75.7012,
    width: 21.4058,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 133.852,
    y: 64.2598,
    width: 13.9385,
    height: 5.00684,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 117.333,
    y: 64.2598,
    width: 13.9385,
    height: 5.00684,
    rx: 1,
    fill: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_7174_39852)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_7174_39852)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7174_39852",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: 56,
    width: 51,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2273 56.6262H-8.22727C-8.65404 56.6262 -9 56.9653 -9 57.3835V81.6165C-9 82.0347 -8.65404 82.3738 -8.22727 82.3738H41.2273C41.654 82.3738 42 82.0347 42 81.6165V57.3835C42 56.9653 41.654 56.6262 41.2273 56.6262Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7174_39852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2273 56.6262H-8.22727C-8.65404 56.6262 -9 56.9653 -9 57.3835V81.6165C-9 82.0347 -8.65404 82.3738 -8.22727 82.3738H41.2273C41.654 82.3738 42 82.0347 42 81.6165V57.3835C42 56.9653 41.654 56.6262 41.2273 56.6262Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.1922 73.1093C35.27 73.1349 42.7948 78.056 45.2655 78.6199C47.7364 79.1838 46.9503 82.4389 46.9503 82.4389H7.13623C7.13623 82.4389 21.1188 74.9291 22.7475 75.3136C24.3759 75.698 24.1512 76.5694 25.555 76.5951C26.9591 76.6207 31.1145 73.0837 33.1922 73.1093Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.38288 69.574C-2.71725 69.6094 -7.54982 76.3953 -9.13664 77.1728C-10.7235 77.9504 -10.2186 82.4389 -10.2186 82.4389H15.3508C15.3508 82.4389 6.37087 72.0835 5.32501 72.6136C4.27915 73.1438 4.42347 74.3454 3.52185 74.3807C2.62021 74.4161 -0.0485086 69.5388 -1.38288 69.574Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7594 75.6207C32.4249 75.6394 27.5922 79.2359 26.0056 79.648C24.4187 80.0601 24.9235 82.4389 24.9235 82.4389H50.493C50.493 82.4389 41.5129 76.9506 40.4672 77.2316C39.4214 77.5126 39.5657 78.1494 38.6641 78.1682C37.7624 78.1869 35.0936 75.602 33.7594 75.6207Z",
    fill: "#D9D9D9"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7174_39852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 110,
    fill: "white",
    transform: "translate(0 0.562378)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7174_39852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(8 24.2666)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7174_39852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 26,
    fill: "white",
    transform: "translate(-9 24.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_7174_39852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(8 56.2666)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_7174_39852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 26,
    fill: "white",
    transform: "translate(-9 56.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.00b05088427e9d2c6ac5a16fbebbcfaf.svg";
export { ForwardRef as ReactComponent };